import { isNil } from 'lodash/fp';
import { type DealerListDataFragment } from '../../../api/fragments/DealerListData';
import { type LanguagePackOptionDataFragment } from '../../../api/fragments/LanguagePackOptionData';

export const retrieveDealerbyId = (allDealers: DealerListDataFragment[], id: string) => {
    const dealer = allDealers.find(dealer => dealer.id === id);

    if (isNil(dealer)) {
        return null;
    }

    return dealer;
};

export const retrieveLanguagebyId = (allLanguages: LanguagePackOptionDataFragment[], languageId: string) => {
    const language = allLanguages.find(language => language.id === languageId);

    if (isNil(language)) {
        return null;
    }

    return language;
};
